import React from "react";
import { observer } from "mobx-react";
import { ProvinceStateViewStore } from "../../store";
import { ProvinceStateViewForm } from "./ProvinceStateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ProvinceStateViewProps = {
  provinceStateViewStore: ProvinceStateViewStore;
};

export const ProvinceStateView: React.FC<ProvinceStateViewProps> = observer(
  ({ provinceStateViewStore }) => {
    return (
      <div>
        <ProvinceStateViewForm
          name_es={provinceStateViewStore.name_esValue}
          name_en={provinceStateViewStore.name_enValue}
          name_pt={provinceStateViewStore.name_ptValue}
          countryValue={provinceStateViewStore.countryValue}
          onPrint={(handlePrint: () => void) =>
            provinceStateViewStore.printProvinceState(handlePrint)
          }
          onCancel={() => provinceStateViewStore.cancelProvinceState()}
          onEdit={
            provinceStateViewStore.isEditEnabled
              ? () => provinceStateViewStore.editProvinceState()
              : undefined
          }
        />
        <ErrorDialog
          open={provinceStateViewStore.errorDialogOpened}
          title={provinceStateViewStore.errorTitle}
          description={provinceStateViewStore.errorDescription}
          onClose={() => provinceStateViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
